









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'CompleteSurveyMessagePage' })
export default class CompleteSurveyMessagePage extends Vue {
  @Prop({ default: '' })
  title?: string

  @Prop({ default: null })
  reason?: string | null

  created (): void {
    this.$store.commit('mainLogo/clearLogos')
  }
}
